// extracted by mini-css-extract-plugin
export default {"navItem":"SidebarLink_navItem__R14k9","navLink":"SidebarLink_navLink__Qb0Hm","activeClassName":"SidebarLink_activeClassName__i7ZXb"};